import { ButtonPrimary } from '@steelbuy/ui-primitive';
import './CreateListingPortalCard.scss';

type CreateListingPortalCardProps = {
    image: string;
    heading: string;
    description: string;
    buttonLabel: string;
    buttonOnClick: () => void;
};

export const CreateListingPortalCard = ({
    image,
    heading,
    description,
    buttonLabel,
    buttonOnClick,
}: CreateListingPortalCardProps) => (
    <div className="create-listing-portal-card-container">
        <img src={image} alt={heading} className="create-listing-portal-card-container__image" />
        <div className="create-listing-portal-card-container__header">{heading}</div>
        <div className="create-listing-portal-card-container__description">{description}</div>
        <div className="create-listing-portal-card-container__children">
            <ButtonPrimary label={buttonLabel} onClick={buttonOnClick} />
        </div>
    </div>
);
